import { regex } from "./_regex";

export const configurations = {
  ...regex,
};
